var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
/* tslint:disable:jsx-no-multiline-js */
import classnames from 'classnames';
import React from 'react';
import List from '../list';
import Icon from '../icon';
const Item = List.Item;
class BoardsTitle extends React.Component {
    constructor() {
        super(...arguments);
        this.renderIcon = () => {
            const { titleIcon = '' } = this.props;
            if (!titleIcon) {
                return null;
            }
            return (<div className={`${this.props.prefixCls}-title-icon-wrapper`}>
         <Icon type={titleIcon}></Icon>
      </div>);
        };
    }
    render() {
        const _a = this.props, { prefixCls, children, titleLeftText, titleRightText, onTitleClick } = _a, restProps = __rest(_a, ["prefixCls", "children", "titleLeftText", "titleRightText", "onTitleClick"]);
        const wrapCls = classnames(`${prefixCls}-title-content`, {});
        return (<div className={wrapCls} onClick={onTitleClick}>
        <List>
          <Item extra={titleRightText} thumb={this.renderIcon()} {...restProps}>{titleLeftText}</Item>
        </List>
      </div>);
    }
}
BoardsTitle.defaultProps = {
    prefixCls: 'bs-number-boards',
};
export default BoardsTitle;



// WEBPACK FOOTER //
// ./components/boards/title.tsx